import { render, staticRenderFns } from "./edition.vue?vue&type=template&id=2aaac93d&scoped=true&"
import script from "./edition.vue?vue&type=script&lang=js&"
export * from "./edition.vue?vue&type=script&lang=js&"
import style0 from "./edition.vue?vue&type=style&index=0&id=2aaac93d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaac93d",
  null
  
)

export default component.exports